import { render, staticRenderFns } from "./ContactosNotificados.vue?vue&type=template&id=165d14f1&scoped=true&"
import script from "./ContactosNotificados.vue?vue&type=script&lang=ts&"
export * from "./ContactosNotificados.vue?vue&type=script&lang=ts&"
import style0 from "./ContactosNotificados.vue?vue&type=style&index=0&id=165d14f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d14f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('165d14f1', component.options)
    } else {
      api.reload('165d14f1', component.options)
    }
    module.hot.accept("./ContactosNotificados.vue?vue&type=template&id=165d14f1&scoped=true&", function () {
      api.rerender('165d14f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ContactosNotificados.vue"
export default component.exports